import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '='
    },
    template: `
        <div class="well color04">
            <div class="heading01">
                <h2>{{ 'licence.Licences' | translate }}</h2>
                <a class="btn add" ng-click="vm.manage()">{{ 'licence.Add licence points' | translate }}</a>
            </div>
            <div class="block02" ng-class="{ open: vm.toggles[$index]===true }" ng-repeat="item in vm.list.items">
                <div class="heading01">
                    <h3 ng-click="vm.toggles[$index]=!vm.toggles[$index];"
                    >{{ item.name }} <span class="tag" ng-class="{
                        color01: vm.USER_LICENCE_STATUS_ENUM.KEYS.NOT_ACQUIRED===item.status,
                        color02: vm.USER_LICENCE_STATUS_ENUM.KEYS.ACQUIRED===item.status
                    }">{{ vm.USER_LICENCE_STATUS_ENUM.LABELS[item.status] }}</span></h3>
                </div>
                <div ng-if="vm.toggles[$index]" class="form tablewrapper">
                    <user-employee-detail-licences-periods
                        periods="item.periods"
                        manage="vm.manage(licencePoint)"
                    />
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, ListFactory, UserResource, ModalService, USER_LICENCE_STATUS_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.ModalService = ModalService;
        this.USER_LICENCE_STATUS_ENUM = USER_LICENCE_STATUS_ENUM;
        this.list = ListFactory.createWithPagination(UserResource.licences.bind(UserResource));
        this.list.fetch({ id: this.user.id });
        this.toggles = [];
    }

    manage (licencePoint) {
        const userId = this.user.id;
        return this.ModalService.open({
            template: `
                <modals-user-employee-licence-points
                    uib-modal-instance="vm.uibModalInstance"
                    licences="vm.licences"
                    licence-point="vm.licencePoint"
                    user-id="vm.userId"
                 />
            `,
            controller ($uibModalInstance, licences) {
                this.uibModalInstance = $uibModalInstance;
                this.licencePoint = licencePoint;
                this.licences = licences;
                this.userId = userId;
            },
            resolve: {
                licences: (LicenceResource) => {
                    return LicenceResource.query({
                        userId,
                        isValid: true,
                        pageSize: 0,
                        expand: 'licencePreconditions'
                    }).$promise;
                }
            },
            size: 'large'
        })
            .then(() => {
                this.list.fetch({ id: this.user.id });
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/licences/index.js